module.exports = __webpack_public_path__ + "img/121.2480e88f.jpg";